import { render, staticRenderFns } from "./ReferenceMatrixFile.vue?vue&type=template&id=1a222bec&lang=pug"
import script from "./ReferenceMatrixFile.vue?vue&type=script&lang=js"
export * from "./ReferenceMatrixFile.vue?vue&type=script&lang=js"
import style0 from "./ReferenceMatrixFile.vue?vue&type=style&index=0&id=1a222bec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports